import React from 'react';
import Menu from './Menu';

function App() {
  return (
    <div>
      <Menu/>
    </div>
  );
}

export default App;
